module.exports = new __parcel__URL__("LandInEditorIllustrationDark.2f9f7913.svg").toString();